import jsonPlaceholder from "../apis/jsonPlaceholder";
import axios from "axios";
import { toast } from "react-toastify";
import store from "../store";
import { toastStyle } from "@styles/styledComponents";
import { ERROR_MESSAGE } from "@utils/constants";
import { getAssignedQuota } from "@utils/utils";

const { users } = store.getState();

axios.defaults.headers.common["Authorization"] =
  users && `Bearer ${users.token}`;

export const fetchPostsAndUsers = () => async (dispatch) => {
  await dispatch(fetchPosts());
  await dispatch(fetchUsers());
};
export const getEmployees = () => async (dispatch) => {
  await dispatch(fetchEmployees());
};

export const getContracts = () => async (dispatch) => {
  await dispatch(fetchContracts());
};

//Action Creator returning a function using Redux-Thunk
export const fetchPosts = () => async (dispatch) => {
  const response = await jsonPlaceholder.get("/posts");
  dispatch({ type: "FETCH_POSTS", payload: response.data });
};

export const fetchUser = (id) => async (dispatch) => {
  const response = await jsonPlaceholder.get(`/users/${id}`);
  dispatch({ type: "FETCH_USER", payload: response.data });
};

export const fetchUsers = () => async (dispatch) => {
  const response = await jsonPlaceholder.get(`/users`);
  dispatch({ type: "FETCH_USER", payload: response.data });
};

export const fetchEmployees = () => async (dispatch) => {
  const response = await axios.get(
    `${process.env.REACT_APP_NODE_API_URL}/employees/`
  );
  dispatch({ type: "FETCH_EMPLOYEES", payload: response.data });
  return response;
};

export const fetchDeletedEmployees = () => async (dispatch) => {
  const response = await axios.get(
    `${process.env.REACT_APP_NODE_API_URL}/employees/deleted-employees/`
  );
  dispatch({ type: "FETCH_DELETED_EMPLOYEES", payload: response.data });
  return response;
};

// Login route without api call
export const login = (payload) => async (dispatch) => {
  dispatch({ type: "LOGIN", payload: payload });
  return payload;
};

export const createEmployee = (payload) => async (dispatch) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODE_API_URL}/employees/create-employee`,
    payload
  );
  if (response.data.success === true) {
    dispatch({ type: "CREATE_EMPLOYEE", payload: response.data });
  }
  return response;
};

export const deleteEmployee = (payload) => async (dispatch) => {
  const response = await axios.put(
    `${process.env.REACT_APP_NODE_API_URL}/employees/delete-employee/${payload}`
  );
  if (response.data.success === true) {
    dispatch({ type: "DELETE_EMPLOYEE", payload: response.data });
  }
  return response;
};

export const restoreEmployee = (payload) => async (dispatch) => {
  const response = await axios.put(
    `${process.env.REACT_APP_NODE_API_URL}/employees/restore-employee/${payload}`
  );
  if (response.data.success === true) {
    dispatch({ type: "RESTORE_EMPLOYEE", payload: response.data });
  }
  return response;
};

export const fetchEmployee = (payload) => async (dispatch) => {
  const response = await axios.get(
    `${process.env.REACT_APP_NODE_API_URL}/employees/get-employee/${payload}`
  );
  dispatch({ type: "FETCH_EMPLOYEE", payload: response.data });
  return response;
};
export const fetchAdjustments = (payload) => async (dispatch) => {
  dispatch({ type: "SET_LOADING", payload: true });
  const response = await axios.get(
    `${process.env.REACT_APP_NODE_API_URL}/adjustment/${payload}`
  );
  dispatch({ type: "SET_LOADING", payload: false });
  dispatch({
    type: "ADD_ADJUSTMENT",
    payload: { adjustments: response.data.data, employee_id: payload },
  });
  return response;
};
export const addAdjustment = (payload) => async (dispatch) => {
  dispatch({ type: "SET_LOADING", payload: true });
  let response;
  try {
    response = await axios.post(
      `${process.env.REACT_APP_NODE_API_URL}/adjustment`,
      { payload }
    );
    if (response.status === 201) {
      dispatch({
        type: "ADD_ADJUSTMENT",
        payload: {
          adjustments: [response.data.data],
          employee_id: payload.employee_id,
        },
      });
      toast.success(response.data.message);
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    toast.error(error.message);
  }
  dispatch({ type: "SET_LOADING", payload: false });
  return response;
};

export const deleteAdjustment = (payload) => async (dispatch) => {
  dispatch({ type: "SET_LOADING", payload: true });
  let response;
  try {
    response = await axios.delete(
      `${process.env.REACT_APP_NODE_API_URL}/adjustment/${payload._id}`
    );
    if (response.data.success) {
      dispatch({
        type: "DELETE_ADJUSTMENT",
        payload: {
          adjustment: response.data.data,
          employee_id: payload.employee,
        },
      });
      toast.success(response.data.message);
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    toast.error(error.message);
  }
  dispatch({ type: "SET_LOADING", payload: false });
  return response;
};

export const updateAdjustment = (payload) => async (dispatch) => {
  dispatch({ type: "SET_LOADING", payload: true });
  let response;
  try {
    response = await axios.put(
      `${process.env.REACT_APP_NODE_API_URL}/adjustment/edit`,
      { payload }
    );
    if (response.status === 201) {
      dispatch({
        type: "UPDATE_ADJUSTMENT",
        payload: {
          adjustment: response.data.data,
          employee_id: payload.employee_id,
        },
      });
      toast.success(response.data.message);
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    toast.error(error.message);
  }
  dispatch({ type: "SET_LOADING", payload: false });
  return response;
};

export const updateEmployee = (payload) => async (dispatch) => {
  const response = await axios.put(
    `${process.env.REACT_APP_NODE_API_URL}/employees/update-employee`,
    payload
  );
  if (response.data.success === true) {
    dispatch({ type: "UPDATE_EMPLOYEE", payload: response.data });
  }
  return response;
};

// ---------------------------------Contract APIS---------------------------------------------------

export const fetchContracts = () => async (dispatch) => {
  const response = await axios.get(
    `${process.env.REACT_APP_NODE_API_URL}/contracts/`
  );
  dispatch({ type: "FETCH_CONTRACTS", payload: response.data });
};

export const fetchContract = (payload) => async (dispatch) => {
  const response = await axios.get(
    `${process.env.REACT_APP_NODE_API_URL}/contracts/get-contract/${payload}`
  );
  if (response.data.success === true) {
    dispatch({ type: "FETCH_CONTRACTS", payload: response.data });
  }
  return response;
};

export const updateContract = (payload) => async (dispatch) => {
  // When switching to Permanent, stamp the moment of change as permanent_set_at
  // (unless already present) and compute yearly_quota from that month.
  // When switching to Probationary, reset yearly_quota to 0 and clear permanent_set_at locally.
  let requestBody = { ...payload };
  if (payload.contract === "Permanent") {
    const permanent_set_at = payload.permanent_set_at || new Date().toISOString();
    const computedQuota = getAssignedQuota(permanent_set_at);
    requestBody = {
      ...requestBody,
      permanent_set_at,
      yearly_quota: computedQuota,
    };
  } else if (payload.contract === "Probationary") {
    requestBody = {
      ...requestBody,
      permanent_set_at: null,
      yearly_quota: 0,
    };
  }

  const response = await axios.put(
    `${process.env.REACT_APP_NODE_API_URL}/contracts/update-contract`,
    requestBody
  );
  if (response.data.success === true) {
    const responsePayload = response.data.payload || {};

    // Attach computed fields locally to keep UI in sync even if backend omits them
    const mergedPayload = {
      ...responsePayload,
      contract: responsePayload.contract || requestBody.contract,
      started_at: responsePayload.started_at || requestBody.started_at,
      ended_at: responsePayload.ended_at || requestBody.ended_at,
      permanent_set_at: requestBody.permanent_set_at ?? responsePayload.permanent_set_at,
      yearly_quota: requestBody.yearly_quota ?? responsePayload.yearly_quota,
    };

    await dispatch(fetchContract(requestBody._id || payload._id));
    dispatch({ type: "UPDATE_EMPLOYEE_CONTRACT", payload: { payload: mergedPayload } });

    // Persist the computed yearly_quota to the employee record so it survives reloads.
    const state = store.getState();
    const employeesState = state.employees?.payload || state.employees || [];
    const employeeId = mergedPayload.employee_id || payload.employeeId;
    const existingEmployee =
      Array.isArray(employeesState) &&
      employeesState.find((emp) => emp._id === employeeId);

    if (employeeId && mergedPayload.yearly_quota !== undefined) {
      const employeeUpdatePayload = existingEmployee
        ? {
            ...existingEmployee,
            contract: mergedPayload.contract,
            contract_id: mergedPayload,
            yearly_quota: mergedPayload.yearly_quota,
          }
        : {
            _id: employeeId,
            yearly_quota: mergedPayload.yearly_quota,
            contract_id: mergedPayload,
            contract: mergedPayload.contract,
          };

      try {
        const empResponse = await axios.put(
          `${process.env.REACT_APP_NODE_API_URL}/employees/update-employee`,
          employeeUpdatePayload
        );
        if (empResponse.data?.payload) {
          dispatch({ type: "UPDATE_EMPLOYEE", payload: empResponse.data });
        }
      } catch (err) {
        // If persistence fails, we still keep UI state updated via reducer; log silently.
        console.warn("Failed to persist yearly_quota to employee:", err);
      }
    }
  }
  return response;
};

// ---------------------------------Payroll APIS---------------------------------------------------
export const fetchPayrolls = (payroll) => async (dispatch) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODE_API_URL}/payrolls/`,
    {
      month: payroll,
    }
  );
  if (response.data.success) {
    dispatch({ type: "FETCH_PAYROLLS", payload: response.data });
    localStorage.setItem("payrolls", JSON.stringify(response.data));
  }
  return response;
};

export const fetchPayrollsOfMonths = (payroll) => async (dispatch) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODE_API_URL}/payrolls/payroll-for-months/${payroll.employeeId}`,
    {
      startMonth: payroll.startMonth,
      endMonth: payroll.endMonth,
      signature: payroll.signature,
      purpose: payroll.purpose
    }
  );

  if (response.data.success) {
    toast.success(response.data.message, {
      position: "bottom-left",
      autoClose: 2500,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "dark",
      type: response.data.success ? "success" : "error",
    });
    dispatch({ type: "CREATE_PAYSLIP", payload: response.data.payload });
  } else {
    toast.success(response.data.message, {
      position: "bottom-left",
      autoClose: 2500,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "dark",
      type: response.data.success ? "success" : "error",
    });
  }
  return response.data;
};

export const deletePayroll = (payload) => async (dispatch) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_NODE_API_URL}/payrolls/delete-payroll/${payload}`
  );
  if (response.data.success === true) {
    dispatch({ type: "DELETE_PAYROLL", payload: response.data });
  }
  return response;
};

export const createPayroll = (payload) => async (dispatch) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODE_API_URL}/payrolls/create-payroll`,
    payload
  );
  if (response.data.success === true) {
    dispatch({ type: "CREATE_PAYROLL", payload: response.data });
  }
  return response;
};

export const updatePayroll = (payload) => async (dispatch) => {
  const response = await axios.put(
    `${process.env.REACT_APP_NODE_API_URL}/payrolls/update-payroll/${payload._id}`,
    payload
  );

  if (response.data.success === true) {
    dispatch({ type: "UPDATE_PAYROLL", payload: response.data });
  }
  return response;
};
export const deletePayrolls = (payrollIds) => async () => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_NODE_API_URL}/payrolls/delete-payrolls`,
      payrollIds // Send the array directly, not as an object
    );
    const { message, success } = response.data;
    if (response.data.success === true) {
      // Handle success
      toast.success(message, {
        ...toastStyle,
        type: success ? "success" : "error",
      });
    } else {
      // Handle error
      toast.error(message, {
        ...toastStyle,
        type: success ? "success" : "error",
      });
    }

    return response;
  } catch (error) {
    console.log("Error", error);
  }
};
// ---------------------------------Leave APIS---------------------------------------------------
export const fetchLeaves = (payload) => async (dispatch) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODE_API_URL}/leave`,
    payload
  );
  if (response.data.success) {
    dispatch({ type: "FETCH_LEAVES", payload: response.data });
  }
  return response;
};

export const updateLeave = (payload, id) => async (dispatch) => {
  const response = await axios.put(
    `${process.env.REACT_APP_NODE_API_URL}/leave/${id}`,
    payload
  );
  if (response.data.success === true) {
    dispatch({ type: "UPDATE_LEAVE", payload: response.data });
  }
  return response;
};

export const deleteLeave = (payload) => async (dispatch) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_NODE_API_URL}/leave/${payload}`
  );
  if (response.data.success === true) {
    dispatch({ type: "DELETE_LEAVE", payload: response.data });
  }
  return response;
};

export const createLeave = (payload) => async () => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODE_API_URL}/leave/create-leave`,
    payload
  );
  if (!response.data.success) toast.error(response.data.message);
  return response;
};

// ---------------------------------Attendance APIS---------------------------------------------------

export const fetchAttendance = (payload) => async (dispatch) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODE_API_URL}/attendance/get-attendance-by-month`,
    payload
  );
  if (response.data.success && typeof dispatch == "function") {
    dispatch({ type: "FETCH_ATTENDANCE", payload: response.data });
  }
  return response;
};

export const updateAttendance = (payload) => async (dispatch) => {
  const response = await axios.put(
    `${process.env.REACT_APP_NODE_API_URL}/attendance`,
    payload
  );
  if (response.data.success) {
    dispatch({ type: "UPDATE_ATTENDANCE", payload: response.data });
  }
  return response;
};

// Work from home: mark a day as WFH
export const markWfh = (employee_id, date) => async (dispatch) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_NODE_API_URL}/attendance/mark-wfh`,
      { employee_id, date }
    );
    if (response.data.success) {
      toast.success(response.data.message);
      dispatch({ type: "UPDATE_ATTENDANCE", payload: response.data });
    } else {
      toast.error(response.data.message || ERROR_MESSAGE);
    }
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || err.message || ERROR_MESSAGE);
    return err.response;
  }
};

// Work from home: unmark a day
export const unmarkWfh = (employee_id, date) => async (dispatch) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_NODE_API_URL}/attendance/unmark-wfh`,
      { employee_id, date }
    );
    if (response.data.success) {
      toast.success(response.data.message);
      dispatch({ type: "UPDATE_ATTENDANCE", payload: response.data });
    } else {
      toast.error(response.data.message || ERROR_MESSAGE);
    }
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || err.message || ERROR_MESSAGE);
    return err.response;
  }
};

// Work from home: get WFH usage for a month (used, limit, remaining)
export const getWfhUsage = (employee_id, month) => async () => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_NODE_API_URL}/attendance/wfh-usage`,
      { employee_id, month }
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || err.message || ERROR_MESSAGE);
    return err.response;
  }
};

// ---------------------------------Shift APIS---------------------------------------------------
export const fetchShifts = () => async (dispatch) => {
  const response = await axios.get(
    `${process.env.REACT_APP_NODE_API_URL}/shift`
  );
  dispatch({ type: "FETCH_SHIFT", payload: response.data });
  return response;
};

export const createshift = (payload) => async (dispatch) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODE_API_URL}/shift/create-shift`,
    payload
  );
  if (response.data.success === true) {
    toast.success(response.data.message);
    dispatch({ type: "CREATE_SHIFT", payload: response.data });
  } else {
    toast.error(response.data.message);
  }
  return response;
};

export const deleteShift = (payload) => async (dispatch) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_NODE_API_URL}/shift/${payload}`
  );
  if (response.data.success === true) {
    dispatch({ type: "DELETE_SHIFT", payload: response.data });
  }
  return response;
};
export const updateShift = (payload, id) => async (dispatch) => {
  const response = await axios.put(
    `${process.env.REACT_APP_NODE_API_URL}/shift/${id}`,
    payload
  );
  if (response.data.success === true) {
    dispatch({ type: "UPDATE_SHIFT", payload: response.data });
  }
  return response;
};
// ------------------------------------------Event APIS--------------------------------------------

export const createEvent = (payload) => async (dispatch) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODE_API_URL}/event/create-event`,
    payload
  );
  if (response.data.success === true) {
    toast.success(response.data.message);
    dispatch({ type: "CREATE_EVENT", payload: response.data });
  } else {
    toast.error(response.data.message);
  }
  return response;
};

export const fetchEvents = () => async (dispatch) => {
  const response = await axios.get(
    `${process.env.REACT_APP_NODE_API_URL}/event`
  );
  dispatch({ type: "FETCH_EVENT", payload: response.data });
  return response;
};

export const deleteEvent = (payload) => async (dispatch) => {
  const response = await axios.get(
    `${process.env.REACT_APP_NODE_API_URL}/event/delete-event/${payload}`
  );
  if (response.data.success === true) {
    dispatch({ type: "DELETE_EVENT", payload: response.data });
  }
  return response;
};

export const updateEvent = (payload, id) => async (dispatch) => {
  const response = await axios.put(
    `${process.env.REACT_APP_NODE_API_URL}/event/update-event/${id}`,
    payload
  );
  if (response.data.success === true) {
    dispatch({ type: "UPDATE_EVENT", payload: response.data });
  }
  return response;
};

// ------------------------------------------Course APIS--------------------------------------------

export const createCourse = (payload) => async (dispatch) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODE_API_URL}/courses/create-course`,
    payload
  );
  if (response.data.success === true) {
    toast.success(response.data.message);
    dispatch({ type: "CREATE_COURSE", payload: response.data });
  } else {
    toast.error(response.data.message);
  }
  return response;
};

export const fetchCourses = () => async (dispatch) => {
  const response = await axios.get(
    `${process.env.REACT_APP_NODE_API_URL}/courses`
  );
  dispatch({ type: "FETCH_COURSE", payload: response.data });
  return response;
};

export const deleteCourse = (payload) => async (dispatch) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_NODE_API_URL}/courses/${payload}`
  );
  if (response.data.success === true) {
    dispatch({ type: "DELETE_COURSE", payload: response.data });
  }
  return response;
};

export const updateCourse = (payload, id) => async (dispatch) => {
  const response = await axios.put(
    `${process.env.REACT_APP_NODE_API_URL}/courses/${id}`,
    payload
  );
  if (response.data.success === true) {
    dispatch({ type: "UPDATE_COURSE", payload: response.data });
  }
  return response;
};
// --------------------------------------------- Employee Requests ---------------------------------------------------
export const fetchRequests = (payload) => async (dispatch) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODE_API_URL}/requests`,
    payload
  );
  if (response.data.success) {
    dispatch({ type: "FETCH_REQUESTS", payload: response.data });
  }
  return response;
};

export const updateRequest = (payload, id) => async (dispatch) => {
  const response = await axios.put(
    `${process.env.REACT_APP_NODE_API_URL}/requests/${id}`,
    payload
  );
  if (response.data.success === true) {
    dispatch({ type: "UPDATE_REQUEST", payload: response.data });
  }
  return response;
};

export const deleteRequest = (payload) => async (dispatch) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_NODE_API_URL}/requests/${payload}`
  );
  if (response.data.success === true) {
    dispatch({ type: "DELETE_REQUEST", payload: response.data });
  }
  return response;
};

// --------------------------------------------- Employee Suggestions ---------------------------------------------------
export const fetchSuggestions = (payload) => async (dispatch) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODE_API_URL}/suggestion`,
    payload
  );
  if (response.data.success) {
    dispatch({ type: "FETCH_SUGGESTIONS", payload: response.data });
  }
  return response;
};

export const updateSuggestion = (payload, id) => async (dispatch) => {
  const response = await axios.put(
    `${process.env.REACT_APP_NODE_API_URL}/suggestion/${id}`,
    payload
  );
  if (response.data.success === true) {
    dispatch({ type: "UPDATE_SUGGESTION", payload: response.data });
  }
  return response;
};

export const deleteSuggestion = (payload) => async (dispatch) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_NODE_API_URL}/suggestion/${payload}`
  );
  if (response.data.success === true) {
    dispatch({ type: "DELETE_SUGGESTION", payload: response.data });
  }
  return response;
};

// --------------------------------------------- On  boarding categories & Tasks ---------------------------------------------------

export const fetchOnBoardingCategories = (payload) => async (dispatch) => {
  try {
    const { category_type } = payload;
    const response = await axios.get(
      `${process.env.REACT_APP_NODE_API_URL}/transition/categories/get_transition_categories?category_type=${category_type}`
    );
    if (category_type === "onboarding") {
      dispatch({ type: "FETCH_ONBOARDING_CATEGORY", payload: response.data });
    } else {
      dispatch({ type: "FETCH_OFFBOARDING_CATEGORY", payload: response.data });
    }
    return response.data;
  } catch (error) {
    toast.error(
      error.message || ERROR_MESSAGE + " while fetching employee onboarding"
    );
  }
};

export const createOnBoardingCategory = (payload) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_NODE_API_URL}/transition/categories/create_transition_categories`,
      payload
    );
    if (response.data) {
      toast.success("Category created successfully");
      if (payload.category_type === "onboarding") {
        dispatch({
          type: "CREATE_ONBOARDING_CATEGORY",
          payload: response.data,
        });
      } else {
        dispatch({
          type: "CREATE_OFFBOARDING_CATEGORY",
          payload: response.data,
        });
      }
      return response;
    }
  } catch (error) {
    toast.error(error.message || ERROR_MESSAGE + " while creating category");
  }
};

export const updateOnBoardingCategory = (payload) => async (dispatch) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_NODE_API_URL}/transition/categories/update_transition_category/${payload.id}`,
      payload
    );
    if (response) {
      toast.success("Category updated successfully");
      dispatch(fetchOnBoardingCategories(payload));
      return response;
    }
  } catch (error) {
    toast.error(error.message || ERROR_MESSAGE + " while updating category");
  }
};

export const deleteOnBoardingCategory = (payload) => async (dispatch) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_NODE_API_URL}/transition/categories/delete_transition_category/${payload.categoryId}`
    );
    if (response.data) {
      toast.success("Category deleted successfully");
    }
    dispatch(fetchOnBoardingCategories(payload));
    return;
  } catch (error) {
    toast.error(error.message || ERROR_MESSAGE + " deleting category");
  }
};

export const createOnBoardingTask = (payload) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_NODE_API_URL}/transition/tasks/create_transition_tasks`,
      payload.task
    );
    if (response.data) {
      toast.success("Task created successfully");
      dispatch(fetchOnBoardingCategories(payload));
    }
    return response;
  } catch (error) {
    toast.error(error.message || ERROR_MESSAGE + " while creating task");
  }
};

export const updateOnBoardingTask = (payload) => async (dispatch) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_NODE_API_URL}/transition/tasks/update_transition_tasks/${payload.task.id}`,
      payload.task
    );
    if (response.data) {
      dispatch(fetchOnBoardingCategories(payload));
      toast.success("Task updated successfully");
    }
    return response;
  } catch (error) {
    toast.error(error.message || ERROR_MESSAGE + " while updating task");
  }
};

export const deleteOnBoardingTask = (payload) => async (dispatch) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_NODE_API_URL}/transition/tasks/delete_transition_tasks/${payload.taskData.task_id}?category_id=${payload.taskData.category_id}`
    );
    if (response.data) {
      toast.success("Task deleted successfully");
      dispatch(fetchOnBoardingCategories(payload));
    }
    return response;
  } catch (error) {
    toast.error(error.message || ERROR_MESSAGE + " while deleting task");
  }
};
// --------------------------------------------- Bankslip APIS ---------------------------------------------------

export const createBankSlip = (payload) => async (dispatch) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODE_API_URL}/bankslip/create-bankslip`,
    payload
  );
  if (response.data.success) {
    toast.success(response.data.message, {
      position: "bottom-left",
      autoClose: 2500,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "dark",
      type: response.data.success ? "success" : "error",
    });
    dispatch({ type: "CREATE_BANKSLIP", payload: response.data.payload });
  } else {
    toast.success(response.data.message, {
      position: "bottom-left",
      autoClose: 2500,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "dark",
      type: response.data.success ? "success" : "error",
    });
  }
  return response;
};

export const fetchBankSlips = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_NODE_API_URL}/bankslip`
    );
    if (response.data.success) {
      dispatch({ type: "FETCH_BANKSLIPS", payload: response.data.payload });
    }
    return response;
  } catch (error) {
    console.error("Error fetching bank slips:", error);
  }
};

export const deleteBankSlip = (bankSlipId) => async (dispatch) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_NODE_API_URL}/bankslip/delete-bankslip/${bankSlipId}`
    );
    if (response.data.success) {
      dispatch({ type: "DELETE_BANKSLIP", payload: response.data });
    }
    return response;
  } catch (error) {
    console.error("Error deleting bank slip:", error);
  }
};

// --------------------------------------------- Payslip APIS ---------------------------------------------------
export const fetchPayslip = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_NODE_API_URL}/payslip`
    );
    if (response.data.success) {
      dispatch({ type: "FETCH_PAYSLIPS", payload: response.data.payload });
    }
    return response;
  } catch (error) {
    console.error("Error fetching pay slips:", error);
  }
};

export const deletePaySlip = (paySlipId) => async (dispatch) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_NODE_API_URL}/payslip/delete-payslip/${paySlipId}`
    );
    if (response.data.success) {
      dispatch({ type: "DELETE_PAYSLIP", payload: response.data });
    }
    return response;
  } catch (error) {
    console.error("Error deleting pay slip:", error);
  }
};
